import http from "../utils/axiosInstance";

class transactionDataService {
  // depost(data:any, token:string) {
  //   return http.post(`/transaction/${userId}/deposit`, data, {
  //     headers: {
  //       Authorization: `Bearer ${token}`,
  //     },
  //   });
  // }
  // withdrawal(data, token) {
  //   return http.post(`/transaction/${userId}/withdraw`, data, {
  //     headers: {
  //       Authorization: `Bearer ${token}`,
  //     },
  //   });
  // }
  getAllTransactions() {
    return http.get(`/transaction`);
  }
  getAllApproved() {
    return http.get(`/transaction/approved`);
  }
  getAllWithdrawalRequest() {
    return http.get(`/transaction/approv`);
  }
  approveWithdraw(userId: string, transactionId: string) {
    return http.post(`/transaction/${userId}/${transactionId}
`);
  }
  getUserTransactions() {
    return http.get(`/transaction/user_transaction`);
  }
  getUserUpprovedTransactions() {
    return http.get(`/transaction/user_approved`);
  }
  deleteWithdraw(id:string|number) {
    return http.delete(`/transaction/${id}/delete`);
  }
}
const transactionService = new transactionDataService();
export default transactionService;
